module.exports = __webpack_public_path__ + "static/media/01_hero_desktop.23391309.jpg";